export default {
	GET_PROMOTION_LIST: (state, data) => {
//		state.list = data.resultList || [];
//		state.item_count = data.queryPage.pageCount;
//		state.total_count = data.queryPage.recordCount;
		state.list = data;
	},
	
	GET_PROMOTION_DETAIL: (state, data) => {
		state.detail = data;
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/promotions/mutations.js